function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 52,
  height: 52,
  rx: 4,
  stroke: "#C7CAD9",
  strokeWidth: 0.7
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 18.25L19.83 18.61L20.793 30.083C20.87 31.02 21.653 31.739 22.593 31.736H33.502C34.399 31.738 35.16 31.078 35.287 30.19L36.236 23.632C36.342 22.899 35.833 22.219 35.101 22.113C35.037 22.104 20.164 22.099 20.164 22.099",
  stroke: "#222741",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.125 25.7949H31.898",
  stroke: "#222741",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1544 35.2031C22.4554 35.2031 22.6984 35.4471 22.6984 35.7471C22.6984 36.0481 22.4554 36.2921 22.1544 36.2921C21.8534 36.2921 21.6104 36.0481 21.6104 35.7471C21.6104 35.4471 21.8534 35.2031 22.1544 35.2031Z",
  fill: "#222741",
  stroke: "#222741",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.4346 35.2031C33.7356 35.2031 33.9796 35.4471 33.9796 35.7471C33.9796 36.0481 33.7356 36.2921 33.4346 36.2921C33.1336 36.2921 32.8906 36.0481 32.8906 35.7471C32.8906 35.4471 33.1336 35.2031 33.4346 35.2031Z",
  fill: "#222741",
  stroke: "#222741",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBuyBkRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyBkRec);
export default __webpack_public_path__ + "static/media/Buy_bk_rec.ec29faab.svg";
export { ForwardRef as ReactComponent };